import React from "react";
import { Container } from "react-bootstrap";
import { House, Search, ChatDotsFill, Bookmark } from "react-bootstrap-icons"; // Added ChatDotsFill
import "./style.css";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import aiMentorIcon from "../../assets/Avatar/aimentor.png"; // Step 1: Import the image

// Pass a prop to handle the click, e.g., onChatClick
const Footer = ({ onChatClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  return (
    <>
      <div className="main-container">
        <Container className="footer-container" fluid>
          
          <div className="footer-item">
            <a onClick={() => navigate("/home")}>
              <div className="footer-icon-wrapper">
                <House
                  size={24}
                  style={path === "/home" ? { color: "#00A8FF" } : { color: "#B1AC9F" }}
                />
                <p
                  className="footer-name"
                  style={path === "/home" ? { color: "#00A8FF" } : { color: "#B1AC9F" }}
                >
                  Home
                </p>
              </div>
            </a>
          </div>

          <div className="footer-center-btn-wrapper">
            <Link 
              className={`main-chat-btn ${path === '/ai-mentor' ? 'main-chat-active' : ''}`} 
              to={"/ai-mentor"}
            >
              <img
                src={aiMentorIcon}
                alt="AI Mentor Chat"
                style={{
                  width: '30px',
                  height: '30px',
                  objectFit: 'contain'
                }}
              />
            </Link>
          </div>

          <div className="footer-item">
            <Link to={"/explore"}>
              <div className="footer-icon-wrapper">
                <Search
                  size={24}
                  style={path === "/explore" ? { color: "#00A8FF" } : { color: "#B1AC9F" }}
                />
                <p
                  className="footer-name"
                  style={path === "/explore" ? { color: "#00A8FF" } : { color: "#B1AC9F" }}
                >
                  Explore
                </p>
              </div>
            </Link>
            {/* <Link to={"/saved_booklist"}>
              <div className="footer-saved">
                  <Bookmark
                    size={20}
                    style={
                      path === "/saved_booklist"
                        ? { color: "#00A8FF" }
                        : { color: "#B1AC9F" }
                    }
                  />

                  <p
                    className="footer-name"
                    style={
                      path === "/saved_booklist"
                        ? { color: "#00A8FF" }
                        : { color: "#B1AC9F" }
                    }
                  >
                    Saved
                  </p>
                </div>
              </Link> */}
          </div>

        </Container>
      </div>
    </>
  );
};

export default Footer;